@if (isLoading()) {
    @for (i of skeletonItems; track i) {
        <si-card class="mb-6 w-full opacity-90" aria-hidden="true">
            <div body class="flex animate-pulse flex-col gap-3 p-6">
                <div class="flex items-center justify-between gap-4">
                    <div class="h-6 w-3/5 rounded bg-gray-200"></div>
                    <div class="h-4 w-20 shrink-0 rounded bg-gray-200"></div>
                </div>
                <div class="flex flex-col gap-2">
                    <div class="h-3 w-full rounded bg-gray-200"></div>
                    <div class="h-3 w-11/12 rounded bg-gray-200"></div>
                    <div class="h-3 w-2/3 rounded bg-gray-200"></div>
                </div>
            </div>
        </si-card>
    }
} @else {
    @for (item of news() | slice: sliceStart : sliceEnd; track item) {
        <div>
            <app-news-item [newsItem]="item"></app-news-item>
        </div>
    }
    <si-pagination
        class="mt-4 flex justify-center"
        [totalRowCount]="totalCount()"
        [pageSize]="pageSize"
        [currentPage]="currentPage"
        (currentPageChange)="pageSelectedChanged($event)"
    ></si-pagination>
}
